var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQrCode = function SvgIconQrCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 3.5A1.75 1.75 0 0 0 3.5 5.25v4.125c0 .966.784 1.75 1.75 1.75h4.125a1.75 1.75 0 0 0 1.75-1.75V5.25a1.75 1.75 0 0 0-1.75-1.75zm.25 5.625V5.5h3.625v3.625zM5.25 12.875a1.75 1.75 0 0 0-1.75 1.75v4.125c0 .966.784 1.75 1.75 1.75h4.125a1.75 1.75 0 0 0 1.75-1.75v-4.125a1.75 1.75 0 0 0-1.75-1.75zM5.5 18.5v-3.625h3.625V18.5zM12.875 5.25c0-.966.784-1.75 1.75-1.75h4.125c.966 0 1.75.784 1.75 1.75v4.125a1.75 1.75 0 0 1-1.75 1.75h-4.125a1.75 1.75 0 0 1-1.75-1.75zm2 .25v3.625H18.5V5.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 13.875a1 1 0 1 0-2 0v2.25a1 1 0 1 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.875a1 1 0 0 1 1 1v.5h1.25a1 1 0 1 1 0 2h-1.25V19.5a1 1 0 0 1-1 1h-3.375a1 1 0 1 1 0-2h2.375v-4.625a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconQrCode;